import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconEyeSlash24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22 6.28a.75.75 0 011.06-1.06l12.5 12.5a.75.75 0 11-1.06 1.06L5.22 6.28zm-1.79 5.295c.87-1.267 1.854-2.308 2.912-3.112l1.071 1.071C6.55 10.162 5.726 10.981 4.97 12c2.04 2.748 4.576 4.044 7.031 4.044.569 0 1.142-.07 1.712-.21l1.204 1.203a8.716 8.716 0 01-2.916.507c-3.178 0-6.267-1.767-8.57-5.12a.75.75 0 010-.849zm5.654-4.612l1.204 1.204A7.122 7.122 0 0112 7.957c2.455 0 4.99 1.295 7.03 4.043-.756 1.019-1.58 1.838-2.443 2.466l1.072 1.071c1.057-.804 2.04-1.845 2.911-3.112a.75.75 0 000-.85C18.267 8.223 15.178 6.456 12 6.456c-.988 0-1.966.17-2.916.507zM9 12c0-.269.035-.53.102-.777l3.675 3.675A3.004 3.004 0 019 12zm2.223-2.898l3.675 3.675a3.004 3.004 0 00-3.675-3.675z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconEyeSlash24);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;